// removed by extract-text-webpack-plugin
module.exports = {"container":"_3Dgug9l3nvVB0o3T7W8gYS","Icon":"_2qmJcoAbYGk9j9nlnX2GJB","Title":"_2VimBRDuCQ9S8kJ9fI3x_1","Email":"-E1XR3tO7gltBr9eRFZAu","Signer":"_1h65FV9BVSu_WqvTu94cgE"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/PubDocumentVerify/DocVerifier/Verify/Viewers/styles.css
// module id = 3025
// module chunks = 0